module.exports = __webpack_public_path__ + "img/button_01.c65ae387.webp";